import { type AddressType } from "#src/types/Address.ts";
import { type RoleType } from "#src/types/Role.ts";

export const PARTY_TYPE = {
  INDIVIDUAL: "Individual",
  ENTITY: "Entity",
};

export type PartyType = (typeof PARTY_TYPE)[keyof typeof PARTY_TYPE];

export interface PartyCreateDTO {
  application_roles_attributes?: ApplicationRoleDTO[];
}
export interface ApplicationRoleDTO {
  role: RoleType;
  beneficiary_amount?: number;
  insured_id?: number;
}

export interface NewPartyDTO {
  addresses_attributes?: { address_type: AddressType }[];
  application_roles_attributes?: ApplicationRoleDTO[];
  irrevocable?: boolean | null;
}
